import { createElement } from 'react';

import {
  ApiBlueprint,
  configApiRef,
  createFrontendPlugin,
  fetchApiRef,
  microsoftAuthApiRef,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

import { armApiRef, ArmApiClient } from './api/ArmApiClient';
import { kaapApiRef, KaapApiClient } from './api/KaapApiClient';
import { rootRouteRef } from './routes';

const kaapApi = ApiBlueprint.make({
  name: 'kaap',
  params: defineParams =>
    defineParams({
      api: kaapApiRef,
      deps: {
        fetchApi: fetchApiRef,
        configApi: configApiRef,
        microsoftAuth: microsoftAuthApiRef,
      },
      factory: ({ fetchApi, configApi, microsoftAuth }) =>
        new KaapApiClient({ fetchApi, configApi, microsoftAuth }),
    }),
});

const armApi = ApiBlueprint.make({
  name: 'arm',
  params: defineParams =>
    defineParams({
      api: armApiRef,
      deps: {
        fetchApi: fetchApiRef,
        microsoftAuth: microsoftAuthApiRef,
      },
      factory: ({ fetchApi, microsoftAuth }) =>
        new ArmApiClient({ fetchApi, microsoftAuth }),
    }),
});

const kaapTenantDependenciesTab = EntityContentBlueprint.make({
  name: 'kaap-tenant-dependencies',
  params: {
    path: '/dependencies',
    title: 'Dependencies',
    filter: 'kind:resource type:kaap-tenant',
    routeRef: rootRouteRef,
    loader: async () => {
      const { KaaPTenantDependenciesContent } = await import(
        './components/KaaPTenantDependenciesContent'
      );
      return createElement(KaaPTenantDependenciesContent);
    },
  },
});

export const kaapFrontendPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'kaap-frontend',
  extensions: [kaapApi, armApi, kaapTenantDependenciesTab],
  routes: {
    root: rootRouteRef,
  },
});
